import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../../shared/theme/useColorScheme";

interface ResultsDesktopDeviceStatusCardStyles {
  deviceCard: ICSSInJSStyle;
  deviceTitleContainer: ICSSInJSStyle;
  deviceIcon: ICSSInJSStyle;
  deviceTypeName: ICSSInJSStyle;
  selectedDevice: ICSSInJSStyle;
  successIcon: ICSSInJSStyle;
  warningIcon: ICSSInJSStyle;
  hyphenIcon: ICSSInJSStyle;
}

export const useResultsDesktopDeviceStatusCardStyles: () => ResultsDesktopDeviceStatusCardStyles =
  () => {
    const { white, grey, main, yellow, green } = useFluentColorScheme();
    return {
      deviceCard: {
        width: "420px",
        height: "78px",
        boxShadow: "none",
        padding: "0px",
        backgroundColor: main.backgroundFocus2,
      },
      deviceTitleContainer: {
        width: "365px",
        height: "100%",
      },
      deviceIcon: {
        color: white.foreground,
        height: "20px",
        width: "20px",
      },
      deviceTypeName: {
        color: white.foreground,
      },
      selectedDevice: {
        color: grey.foreground2,
        maxWidth: "330px",
      },
      successIcon: {
        backgroundColor: green.foreground2,
        color: main.background,
      },
      warningIcon: {
        color: yellow.background,
      },
      hyphenIcon: {
        color: white.foreground,
      },
    };
  };
